/** The Objectives card's tooltips, shown with HelpTip beside each title. */
export const OBJECTIVES_HELP = {
  overview:
    'What this experiment is judged on, picked from the events this website sends. Mapping an event in the website settings only decides what is offered first.',
  primary:
    "Decides the result: the winner and its significance are computed on this event. Website default follows the conversion event set in the website's settings.",
  secondary:
    'Reported next to the primary as supporting evidence, in this order. They never change the verdict, and the primary cannot also be one.',
} as const;
